export class PropertyNoteDTO{
    public id?:number;
    public propertyId!:number;
    public note!:string;
    public userId?:string;
    public userName?:string;
    public userFirstName?:string;
    public userLastName?:string;
    public added?:string;
    public edited?:string;
    public context?:string;
    public contextId?:string;
    /** who may see the note besides super admins (bitmask): 0=super admin only, 1=client users, 2=attorneys (reserved). undefined = not specified */
    public visibleTo?:number;
}